import { Component } from 'react'
import {AnnotationModelIcon }from '../../../../Templates/icons';

export default class ModelAnnotationButton extends Component {
    
    toggleButton = () => {
     var toggle = this.props.toggleAnnotation

        if (typeof toggle === "undefined" || toggle === null)
        {
            toggle = false
        }
        else{
            if(this.props.toggleAnnotation === true) {
                toggle = false
            }else
            {
                toggle = true
            }

        }
        //this.props.toggleAnnotation = toggle
        this.props.updateToggleAnnotation(toggle)
    }

   renderModelAnnotationPage = () => { 
       // alert("test");   
        this.toggleButton()      
    }
   

    render() {
     var  props = this.props
        {console.log("model annotation disabled:" + props.isDisabled)}
        return AnnotationModelIcon(this.toggleButton,props.isDisabled )

    }
}